const Backbone = require('backbone');
const FacetDictionaryModel = Backbone.Model.extend({
	defaults: {
		fetched: false
	},
	url: function() {
		return `/app/api/search/dictionary/${this.get('dictionaryId')}/${window.encodeURIComponent(this.get('term'))}`;
	},

	api: 'local'
});

module.exports = FacetDictionaryModel;
